import React from 'react'
import Page from '../components/Page'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, Table, CardBody, CardHeader, Col, Label, Row, Nav, NavItem, NavLink, TabContent, TabPane, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup, FormGroup, Spinner } from 'reactstrap'
import { MdEdit, MdDone, MdClear, MdCreate, MdDelete, MdSettings, MdShoppingCart, MdWarning } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from 'axios'
import { getProductCategory_v2 } from '../utils/dropdownlist'
import classnames from 'classnames'
import { MDBDataTableV5, MDBDataTable } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import PosStorePriceModificationForm from '../components/PosStorePriceModificationForm'
import moment from 'moment-timezone'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'

let tbcolumn = [
  {
    label: <input type="checkbox" />,
    field: 'checkbox',
    sort: 'disabled',
  },
  {
    label: 'Product No.',
    field: 'product_no',
    sort: 'asc',
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
  },
  {
    label: 'Price',
    field: 'price',
    sort: 'asc',
  },
  {
    label: 'Start Date',
    field: 'start_dt',
    sort: 'asc',
  },
  {
    label: 'End Date',
    field: 'end_dt',
    sort: 'asc',
  },
  {
    label: 'Min Qty',
    field: 'min_qty',
    sort: 'asc',
  },
  {
    label: 'Max Qty',
    field: 'max_qty',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class PosStorePriceModificationPage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')
  access = StorageService.getSession('user_access')

  constructor(props) {
    //let storeRole = this.access.store.find(x => x.store_id == storeid).role;
    super(props)
    this.state = {
      isEdit: false,
      isCopy: false,
      role: this.access.store.find(x => x.store_id == this.props.match.params.id).role,
      storeRole: this.access.store.find(x => x.store_id == this.props.match.params.id).role,
      isLoading: false,
      store_id: this.props.match.params.id,
      productList: [],
      sortKey: '',
      pricemod: [],
      categoryList: [],
      bulkDelete: false,
      checkedRows: [],
      modal: false,
      confirmModal: false,
    }
  }

  componentDidMount() {
    this.getProductCategory()
    this.PriceMod()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleCheck = (e, isall) => {
    let checkedRows = []
    if (isall) {
      if (e.target.checked) {
        for (let i of this.state.filterpricemod) {
          checkedRows.push(i.id)
        }
      } else checkedRows = []
    } else {
      checkedRows = [...this.state.checkedRows]
      if (e.target.checked) checkedRows.push(e.target.name)
      else checkedRows.splice(checkedRows.indexOf(e.target.name), 1)
    }
    this.setState(
      {
        checkedRows,
        bulkDelete: isall ? (e.target.checked ? true : false) : false,
      },
      () => this.custData('check', this.state.filterpricemod),
    )
  }

  handleCheckHeader = (e, isall) => {
    let checkedRows = []
    if (e.target.checked) {
      for (let i of this.state.filterpricemod) {
        checkedRows.push(i.id)
      }
    } else checkedRows = []
    this.setState(
      {
        checkedRows,
        bulkDelete: e.target.checked,
      },
      () => this.custData('check', this.state.filterpricemod),
    )
  }

  handleCheckItem = (e, isall) => {
    let { name } = e.target
    let id = parseInt(name)
    let checkedRows = []
    checkedRows = [...this.state.checkedRows]
    if (e.target.checked) checkedRows.push(id)
    else checkedRows.splice(checkedRows.indexOf(id), 1)
    this.setState(
      {
        checkedRows,
        //bulkDelete: isall ? (e.target.checked ? true : false) : false,
      },
      () => this.custData('check', this.state.filterpricemod),
    )
  }

  PriceMod = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')

    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/price_mod', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        return result.data
      })
      .then(data => {
        this.custData('api', data)
      })
      .catch(error => {
        alert(error)
      })
  }

  custData(method, data) {
    tbcolumn[0].label = (
      <Input
        type="checkbox"
        checked={this.state.bulkDelete}
        onChange={e => {
          this.handleCheckHeader(e, true)
        }}
      />
    )
    for (let i of data) {
      i.checkbox = (
        <Input
          type="checkbox"
          name={i.id}
          checked={this.state.checkedRows.some(j => j == i.id)}
          onChange={e => {
            this.handleCheckItem(e, false)
          }}
        />
      )

      i.Action = (
        <div className="ps-button-group">
          <div className="ps-action-button">
            <Button className="theme-button theme-button-primary" onClick={this.toggle('EDIT', i.id)}>
              Edit
            </Button>
            <Button className="theme-button theme-button-secondary" onClick={this.toggle('COPY', i.id)}>
              Copy
            </Button>
            <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(i.id)}>
              Delete
            </Button>
          </div>
        </div>
      )

      i.price = ''
      if (i.price_data) {
        i.price = JSON.parse(i.price_data)[0].price
        i.unit = JSON.parse(i.price_data)[0].unit
      }
    }

    let item = data
    if (this.state.sortKey) {
      item = this.state.sortKey == '' ? this.state.pricemod : data.filter(x => x.category === this.state.sortKey)
    }

    this.setState({
      filterpricemod: item,
      pricemod: method == 'api' ? data : this.state.pricemod,
    })
  }

  getProductCategory() {
    getProductCategory_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            categoryList: result.data.data,
          })
        }
      })
      .then(() => {
        this.getProductList()
      })
      .catch(error => {
        alert(error)
      })
  }

  getProductList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
    }
    axios
      .post(url + ':3002/v1/product/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            productList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  filterData() {
    const { pricemod, sortKey } = this.state

    if (sortKey.length) {
      let item = pricemod.filter(x => x.category === sortKey)
      this.setState({ filterpricemod: item }, () => this.custData('filter', item))
    } else {
      this.setState({ filterpricemod: pricemod }, () => this.custData('filter', pricemod))
    }

    this.setState({
      bulkDelete: false,
      checkedRows: [],
    })
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != null && action == 'EDIT' ? true : false,
      isCopy: id != null && action == 'COPY' ? true : false,
      selectedId: id,
    })
  }

  toggleConfirmModal = id => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.PriceMod()
    }
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  confirm = () => {
    if (this.state.checkedRows.length > 0) {
      this.batchdelete()
    } else {
      this.delete()
    }
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      price_id: this.state.selectedId,
      remove_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Price Modification deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.PriceMod()
      })
      .catch(error => {
        alert(error)
      })
  }

  batchdelete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      price_id_list: this.state.checkedRows,
      remove_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/delete/batch', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Price Modification deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false, checkedRows: [], bulkDelete: false })
        this.PriceMod()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    // console.log(this.state.bulkDelete)
    const data = {
      columns: tbcolumn,
      rows: this.state.filterpricemod,
    }

    return (
      <Page
        className="PosStorePriceModificationPage"
        title="Price Modification"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posstore' },
          { name: 'Detail', active: false, path: '/posstore/' + this.state.store_id },
          { name: 'Price Modification', active: true, path: '/posstore:id/pricemodification' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Label className="text-center" for="sortBy" sm={2}>
                        Category
                      </Label>

                      <Col sm={4}>
                        <Input type="select" name="sortKey" value={this.state.sortKey} onChange={this.changeHandler}>
                          <option value="">Default</option>
                          {this.state.categoryList.map(item => {
                            return <option key={item.id}>{item.name}</option>
                          })}
                        </Input>
                      </Col>
                      <Col sm={2}>
                        <Button
                          className="theme-button theme-button-dark"
                          onClick={() => {
                            this.filterData()
                          }}>
                          Filter
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Button color="link" onClick={this.toggle('ADD', null)} style={{ float: 'right' }}>
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <BsPlusSquareFill size={25} />
                      </IconContext.Provider>
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Button type="button" className="ps-input-small theme-button-primary" onClick={this.toggleConfirmModal()} disabled={this.state.checkedRows.length > 0 ? false : true}>
                      Delete
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {this.state.pricemod.length > 0 ? (
                      <MDBDataTable className="ps-pm-table ps-mdb-table th-10" data={data} displayEntries={false} searchTop searchBottom={false} entries={50} fullPagination disableRetreatAfterSorting={true} responsive />
                    ) : (
                      <Table responsive hover className="ps-table tb-col-10">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Product No.</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Price</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Min Qty</th>
                            <th>Max Qty</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.isLoading ? (
                            <tr>
                              <td colSpan="11">
                                <div
                                  style={{
                                    minHeight: '100px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}>
                                  <Spinner animation="border" variant="primary" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan="11">
                                <div className="ps-empty-data">
                                  <div className="empty-content">
                                    <MdCreate />
                                    <h4>No data to show</h4>
                                    <span>Click the 'Create' button to add new product</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosStorePriceModificationForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Price Modification</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.checkedRows.length > 0 ? 'selected items' : 'this item'} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.confirm()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </Page>
    )
  }
}

export default PosStorePriceModificationPage
